module.exports = __webpack_public_path__ + "content/20be72ab1ebfcbe3673cd2962df92f27.jpg";